var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "invoice-add-wrapper" },
    [
      _c(
        "b-row",
        { staticClass: "invoice-add" },
        [
          _c(
            "b-col",
            { attrs: { cols: "12", xl: "9", md: "8" } },
            [
              _c(
                "validation-observer",
                { ref: "proforma" },
                [
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _c(
                        "b-card",
                        {
                          staticClass: "invoice-preview-card",
                          attrs: { "no-body": "" },
                        },
                        [
                          _c(
                            "b-card-body",
                            { staticClass: "invoice-padding pb-0" },
                            [
                              _c(
                                "div",
                                { staticClass: "row align-items-center mb-2" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-3" },
                                    [_c("Logo")],
                                    1
                                  ),
                                  _c("div", { staticClass: "col-9" }, [
                                    _c("div", {}, [_c("CompanyName")], 1),
                                    _c("div", {}, [_c("Address")], 1),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-end flex-md-row flex-column invoice-spacing mt-0",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "invoice-number-date mt-md-0 mt-2",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center justify-content-md-end mb-1",
                                        },
                                        [
                                          _c(
                                            "h4",
                                            { staticClass: "invoice-title" },
                                            [_vm._v("Proforma Invoice")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center mb-1",
                                        },
                                        [
                                          _c("span", { staticClass: "title" }, [
                                            _vm._v(" Date: "),
                                          ]),
                                          _c(
                                            "div",
                                            [
                                              _c("flat-pickr", {
                                                staticClass:
                                                  "form-control invoice-edit-input",
                                                attrs: {
                                                  config: _vm.config.wrap,
                                                },
                                                model: {
                                                  value: _vm.issuedDate,
                                                  callback: function ($$v) {
                                                    _vm.issuedDate = $$v
                                                  },
                                                  expression: "issuedDate",
                                                },
                                              }),
                                              _vm.issueDateError
                                                ? _c(
                                                    "small",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.issueDateError
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center mb-1",
                                        },
                                        [
                                          _c("validation-provider", {
                                            attrs: {
                                              rules: "required",
                                              name: "Due Date",
                                              vid: "Due Date",
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c(
                                                      "div",
                                                      { staticClass: "d-flex" },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "title",
                                                          },
                                                          [_vm._v("Due Date:*")]
                                                        ),
                                                        _c(
                                                          "div",
                                                          [
                                                            _c("flat-pickr", {
                                                              staticClass:
                                                                "form-control invoice-edit-input",
                                                              attrs: {
                                                                config:
                                                                  _vm.configDue
                                                                    .wrap,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.dueDate,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.dueDate =
                                                                      $$v
                                                                  },
                                                                expression:
                                                                  "dueDate",
                                                              },
                                                            }),
                                                            _vm.dueDateError
                                                              ? _c(
                                                                  "small",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.dueDateError
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            errors.length
                                                              ? _c(
                                                                  "small",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ]),
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center mb-1",
                                        },
                                        [
                                          _c("span", { staticClass: "title" }, [
                                            _vm._v(" Select Currency:* "),
                                          ]),
                                          _c("b-form-select", {
                                            staticStyle: { width: "100px" },
                                            attrs: {
                                              id: "currencySelect",
                                              size: "lg",
                                              options: _vm.currencyOptions,
                                            },
                                            model: {
                                              value: _vm.selectedCurrency,
                                              callback: function ($$v) {
                                                _vm.selectedCurrency = $$v
                                              },
                                              expression: "selectedCurrency",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm.selectedCurrency !== "MUR"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center mb-1",
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "title" },
                                                [_vm._v(" Enter rate:* ")]
                                              ),
                                              _c("validation-provider", {
                                                attrs: {
                                                  rules:
                                                    "required|min_value:0.01",
                                                  name: "Rate",
                                                  vid: "Rate",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var errors = ref.errors
                                                        return [
                                                          _c("b-form-input", {
                                                            staticStyle: {
                                                              width: "150px",
                                                            },
                                                            attrs: {
                                                              id: "exchangeRate",
                                                              placeholder:
                                                                "Enter rate",
                                                              type: "number",
                                                              size: "lg",
                                                            },
                                                            on: {
                                                              onkeydown:
                                                                function (
                                                                  $event
                                                                ) {
                                                                  return _vm.numericValidation(
                                                                    _vm.event
                                                                  )
                                                                },
                                                              blur: _vm.updateInvoiceDataOnRateChange,
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.exchangeRate,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.exchangeRate =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "exchangeRate",
                                                            },
                                                          }),
                                                          errors.length
                                                            ? _c(
                                                                "small",
                                                                {
                                                                  staticClass:
                                                                    "text-danger",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      errors[0]
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  2393304256
                                                ),
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c("hr", { staticClass: "invoice-spacing" }),
                          _c(
                            "b-card-body",
                            { staticClass: "invoice-padding pt-0" },
                            [
                              _c(
                                "b-row",
                                { staticClass: "invoice-spacing" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-lg-1",
                                      attrs: { cols: "6", xl: "6" },
                                    },
                                    [
                                      _c("h6", { staticClass: "mb-2" }, [
                                        _vm._v("Send Proforma To:"),
                                      ]),
                                      _vm.whenSelected !== null
                                        ? _c(
                                            "div",
                                            { staticClass: "mt-1" },
                                            [
                                              _c(
                                                "b-card-text",
                                                { staticClass: "mb-25" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.whenSelected
                                                          .otherName
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "b-card-text",
                                                { staticClass: "mb-25" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.whenSelected
                                                          .addressLine1
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.whenSelected
                                                          .addressLine2
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "b-card-text",
                                                { staticClass: "mb-25" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.whenSelected.city
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "b-card-text",
                                                { staticClass: "mb-25" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.whenSelected.tel
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "b-card-text",
                                                { staticClass: "mb-0" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.whenSelected.email
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-card-body",
                            { staticClass: "invoice-padding" },
                            [
                              _c(
                                "div",
                                {
                                  ref: "form",
                                  staticClass: "repeater-form",
                                  style: { height: _vm.trHeight },
                                },
                                _vm._l(
                                  _vm.invoiceData.items,
                                  function (item, index) {
                                    return _c(
                                      "b-row",
                                      {
                                        key: "items_" + index,
                                        ref: "row",
                                        refInFor: true,
                                        staticClass: "pb-2",
                                      },
                                      [
                                        _c("b-col", { attrs: { cols: "12" } }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex border rounded",
                                            },
                                            [
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "b-row",
                                                    {
                                                      staticClass:
                                                        "flex-grow-1 p-2 pt-2",
                                                    },
                                                    [
                                                      _c(
                                                        "b-col",
                                                        {
                                                          attrs: {
                                                            cols: "12",
                                                            lg: _vm.vat ? 6 : 8,
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "static-label",
                                                            },
                                                            [_vm._v("Items*")]
                                                          ),
                                                          _vm.newProd
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "d-flex justify-content-center",
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-spinner",
                                                                    {
                                                                      attrs: {
                                                                        variant:
                                                                          "primary",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "d-flex",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "flex-grow-1 mr-1",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "validation-provider",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              rules:
                                                                                "required",
                                                                              name: "Item",
                                                                              vid:
                                                                                "Item_" +
                                                                                index,
                                                                            },
                                                                          scopedSlots:
                                                                            _vm._u(
                                                                              [
                                                                                {
                                                                                  key: "default",
                                                                                  fn: function (
                                                                                    ref
                                                                                  ) {
                                                                                    var errors =
                                                                                      ref.errors
                                                                                    return [
                                                                                      _c(
                                                                                        "v-select",
                                                                                        {
                                                                                          class:
                                                                                            [
                                                                                              {
                                                                                                "is-invalid":
                                                                                                  errors.length,
                                                                                              },
                                                                                              "item-selector-title",
                                                                                            ],
                                                                                          attrs:
                                                                                            {
                                                                                              options:
                                                                                                _vm.optionsProduct,
                                                                                              label:
                                                                                                "itemTitle",
                                                                                              dir: _vm
                                                                                                .$store
                                                                                                .state
                                                                                                .appConfig
                                                                                                .isRTL
                                                                                                ? "rtl"
                                                                                                : "ltr",
                                                                                              clearable: false,
                                                                                              searchable: true,
                                                                                              placeholder:
                                                                                                "Select Item",
                                                                                            },
                                                                                          on: {
                                                                                            input:
                                                                                              function (
                                                                                                val
                                                                                              ) {
                                                                                                _vm.updateItemForm(
                                                                                                  index,
                                                                                                  val,
                                                                                                  _vm.exchangeRate,
                                                                                                  _vm.selectedCurrency
                                                                                                )
                                                                                                //updateInvoiceDataOnRateChange();
                                                                                              },
                                                                                          },
                                                                                          scopedSlots:
                                                                                            _vm._u(
                                                                                              [
                                                                                                {
                                                                                                  key: "option",
                                                                                                  fn: function (
                                                                                                    ref
                                                                                                  ) {
                                                                                                    var itemTitle =
                                                                                                      ref.itemTitle
                                                                                                    var categoryName =
                                                                                                      ref.categoryName
                                                                                                    var subCategoryName =
                                                                                                      ref.subCategoryName
                                                                                                    return [
                                                                                                      _c(
                                                                                                        "div",
                                                                                                        {
                                                                                                          staticStyle:
                                                                                                            {
                                                                                                              display:
                                                                                                                "flex",
                                                                                                              "flex-direction":
                                                                                                                "column",
                                                                                                            },
                                                                                                        },
                                                                                                        [
                                                                                                          _c(
                                                                                                            "span",
                                                                                                            [
                                                                                                              _vm._v(
                                                                                                                _vm._s(
                                                                                                                  itemTitle
                                                                                                                )
                                                                                                              ),
                                                                                                            ]
                                                                                                          ),
                                                                                                          _c(
                                                                                                            "span",
                                                                                                            [
                                                                                                              _vm._v(
                                                                                                                _vm._s(
                                                                                                                  categoryName ||
                                                                                                                    "-"
                                                                                                                ) +
                                                                                                                  " : " +
                                                                                                                  _vm._s(
                                                                                                                    subCategoryName ||
                                                                                                                      "-"
                                                                                                                  )
                                                                                                              ),
                                                                                                            ]
                                                                                                          ),
                                                                                                        ]
                                                                                                      ),
                                                                                                    ]
                                                                                                  },
                                                                                                },
                                                                                              ],
                                                                                              null,
                                                                                              true
                                                                                            ),
                                                                                          model:
                                                                                            {
                                                                                              value:
                                                                                                item.id,
                                                                                              callback:
                                                                                                function (
                                                                                                  $$v
                                                                                                ) {
                                                                                                  _vm.$set(
                                                                                                    item,
                                                                                                    "id",
                                                                                                    $$v
                                                                                                  )
                                                                                                },
                                                                                              expression:
                                                                                                "item.id",
                                                                                            },
                                                                                        }
                                                                                      ),
                                                                                      errors.length
                                                                                        ? _c(
                                                                                            "small",
                                                                                            {
                                                                                              staticClass:
                                                                                                "text-danger",
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                _vm._s(
                                                                                                  errors[0]
                                                                                                )
                                                                                              ),
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e(),
                                                                                    ]
                                                                                  },
                                                                                },
                                                                              ],
                                                                              null,
                                                                              true
                                                                            ),
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _c(
                                                                    "div",
                                                                    [
                                                                      _c(
                                                                        "b-button",
                                                                        {
                                                                          directives:
                                                                            [
                                                                              {
                                                                                name: "ripple",
                                                                                rawName:
                                                                                  "v-ripple.400",
                                                                                value:
                                                                                  "rgba(113, 102, 240, 0.15)",
                                                                                expression:
                                                                                  "'rgba(113, 102, 240, 0.15)'",
                                                                                modifiers:
                                                                                  {
                                                                                    400: true,
                                                                                  },
                                                                              },
                                                                              {
                                                                                name: "b-modal",
                                                                                rawName:
                                                                                  "v-b-modal.modal-addProduct",
                                                                                modifiers:
                                                                                  {
                                                                                    "modal-addProduct": true,
                                                                                  },
                                                                              },
                                                                            ],
                                                                          attrs:
                                                                            {
                                                                              variant:
                                                                                "primary",
                                                                              size: "md",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " + "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "b-col",
                                                        {
                                                          attrs: {
                                                            cols: "12",
                                                            lg: "2",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "static-label",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Unit Price (" +
                                                                  _vm._s(
                                                                    _vm.selectedCurrencySign
                                                                  ) +
                                                                  ")*"
                                                              ),
                                                            ]
                                                          ),
                                                          _c("b-form-input", {
                                                            staticClass: "mb-2",
                                                            attrs: {
                                                              type: "number",
                                                            },
                                                            on: {
                                                              keypress:
                                                                function (
                                                                  $event
                                                                ) {
                                                                  return _vm.allowOnlyNumbers(
                                                                    $event
                                                                  )
                                                                },
                                                              input: function (
                                                                $event
                                                              ) {
                                                                return _vm.sanitizeInput(
                                                                  "cost"
                                                                )
                                                              },
                                                            },
                                                            model: {
                                                              value: item.cost,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    item,
                                                                    "cost",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "item.cost",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _vm.vat
                                                        ? _c(
                                                            "b-col",
                                                            {
                                                              attrs: {
                                                                cols: "12",
                                                                lg: "2",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "static-label",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " VAT (%)"
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "b-form-input",
                                                                {
                                                                  staticClass:
                                                                    "mb-2",
                                                                  attrs: {
                                                                    type: "number",
                                                                  },
                                                                  on: {
                                                                    keypress:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.allowOnlyNumbers(
                                                                          $event
                                                                        )
                                                                      },
                                                                    input:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.sanitizeInput(
                                                                          "tax"
                                                                        )
                                                                      },
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      item.tax,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          item,
                                                                          "tax",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "item.tax",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _c(
                                                        "b-col",
                                                        {
                                                          attrs: {
                                                            cols: "12",
                                                            lg: "2",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-flex align-items-center justify-content-between",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "flex-grow-1",
                                                                },
                                                                [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "static-label",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Qty*"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "validation-provider",
                                                                    {
                                                                      attrs: {
                                                                        rules:
                                                                          "required|min_value:1",
                                                                        name: "Quantity",
                                                                        vid:
                                                                          "Quantity" +
                                                                          index,
                                                                      },
                                                                      scopedSlots:
                                                                        _vm._u(
                                                                          [
                                                                            {
                                                                              key: "default",
                                                                              fn: function (
                                                                                ref
                                                                              ) {
                                                                                var errors =
                                                                                  ref.errors
                                                                                return [
                                                                                  _c(
                                                                                    "b-form-input",
                                                                                    {
                                                                                      class:
                                                                                        [
                                                                                          {
                                                                                            "is-invalid":
                                                                                              errors.length,
                                                                                          },
                                                                                          "mb-2",
                                                                                        ],
                                                                                      attrs:
                                                                                        {
                                                                                          type: "number",
                                                                                        },
                                                                                      on: {
                                                                                        keypress:
                                                                                          function (
                                                                                            $event
                                                                                          ) {
                                                                                            return _vm.allowOnlyNumbers(
                                                                                              $event
                                                                                            )
                                                                                          },
                                                                                        input:
                                                                                          function (
                                                                                            $event
                                                                                          ) {
                                                                                            return _vm.sanitizeInput(
                                                                                              "qty"
                                                                                            )
                                                                                          },
                                                                                      },
                                                                                      model:
                                                                                        {
                                                                                          value:
                                                                                            item.qty,
                                                                                          callback:
                                                                                            function (
                                                                                              $$v
                                                                                            ) {
                                                                                              _vm.$set(
                                                                                                item,
                                                                                                "qty",
                                                                                                $$v
                                                                                              )
                                                                                            },
                                                                                          expression:
                                                                                            "item.qty",
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                  errors.length
                                                                                    ? _c(
                                                                                        "small",
                                                                                        {
                                                                                          staticClass:
                                                                                            "text-danger",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              errors[0]
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      )
                                                                                    : _vm._e(),
                                                                                ]
                                                                              },
                                                                            },
                                                                          ],
                                                                          null,
                                                                          true
                                                                        ),
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "mb-1",
                                                            },
                                                            [
                                                              _c(
                                                                "b-button",
                                                                {
                                                                  attrs: {
                                                                    variant:
                                                                      "danger",
                                                                    size: "sm",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.removeItem(
                                                                          index
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " Remove "
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "b-col",
                                                        {
                                                          attrs: {
                                                            cols: "12",
                                                            lg: "12",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "d-inline d-lg-none",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Description"
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "b-form-textarea",
                                                            {
                                                              staticClass:
                                                                "mb-2 mb-lg-0",
                                                              model: {
                                                                value:
                                                                  item.description,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      item,
                                                                      "description",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "item.description",
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c("hr"),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              ),
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "ripple",
                                      rawName: "v-ripple.400",
                                      value: "rgba(255, 255, 255, 0.15)",
                                      expression: "'rgba(255, 255, 255, 0.15)'",
                                      modifiers: { 400: true },
                                    },
                                  ],
                                  attrs: { size: "sm", variant: "primary" },
                                  on: { click: _vm.addNewItemInItemForm },
                                },
                                [_vm._v(" Add Item ")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-card-body",
                            { staticClass: "invoice-padding pb-0" },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "mt-md-0 mt-3 d-flex align-items-center",
                                      attrs: {
                                        cols: "12",
                                        md: "4",
                                        order: "2",
                                        "order-md": "1",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text-nowrap mr-50",
                                                  attrs: {
                                                    for: "invoice-data-sales-person",
                                                  },
                                                },
                                                [_vm._v("Sales Person:*")]
                                              ),
                                              _c("validation-provider", {
                                                attrs: {
                                                  rules: "required",
                                                  name: "Sales Person",
                                                  vid: "Sales Person",
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function (ref) {
                                                      var errors = ref.errors
                                                      return [
                                                        _c("b-form-select", {
                                                          attrs: {
                                                            options:
                                                              _vm.optionsSalesPerson,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.salesPersonId,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.salesPersonId =
                                                                $$v
                                                            },
                                                            expression:
                                                              "salesPersonId",
                                                          },
                                                        }),
                                                        errors.length
                                                          ? _c(
                                                              "small",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ]),
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "box-1" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-nowrap mr-50",
                                                      attrs: {
                                                        for: "invoice-data-warehouse",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Choose Warehouse:*"
                                                      ),
                                                    ]
                                                  ),
                                                  _c("validation-provider", {
                                                    attrs: {
                                                      rules: "required",
                                                      name: "Warehouse",
                                                      vid: "Warehouse",
                                                    },
                                                    scopedSlots: _vm._u([
                                                      {
                                                        key: "default",
                                                        fn: function (ref) {
                                                          var errors =
                                                            ref.errors
                                                          return [
                                                            _c(
                                                              "b-form-select",
                                                              {
                                                                attrs: {
                                                                  options:
                                                                    _vm.optionsWarehouse,
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.warehouseId,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.warehouseId =
                                                                        $$v
                                                                    },
                                                                  expression:
                                                                    "warehouseId",
                                                                },
                                                              }
                                                            ),
                                                            errors.length
                                                              ? _c(
                                                                  "small",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        },
                                                      },
                                                    ]),
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "mt-md-6 d-flex justify-content-end",
                                      attrs: {
                                        cols: "12",
                                        md: "8",
                                        order: "1",
                                        "order-md": "2",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "invoice-total-wrapper",
                                        },
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c("b-col", [
                                                _vm._v(" Discount Rate: "),
                                              ]),
                                              _c(
                                                "b-col",
                                                [
                                                  _c("validation-provider", {
                                                    attrs: {
                                                      rules:
                                                        "min_value:0|max_value:" +
                                                        _vm.maxDiscountValue,
                                                      name: "Discount",
                                                      vid:
                                                        "Discount_" + _vm.index,
                                                    },
                                                    scopedSlots: _vm._u([
                                                      {
                                                        key: "default",
                                                        fn: function (ref) {
                                                          var errors =
                                                            ref.errors
                                                          return [
                                                            _c("b-form-input", {
                                                              attrs: {
                                                                id: "invoice-discount-value",
                                                                type: "number",
                                                                placeholder:
                                                                  _vm.discountPlaceholder,
                                                              },
                                                              on: {
                                                                blur: _vm.ensureMainDiscountNotNull,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.MainDiscount,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.MainDiscount =
                                                                      $$v
                                                                  },
                                                                expression:
                                                                  "MainDiscount",
                                                              },
                                                            }),
                                                            errors.length
                                                              ? _c(
                                                                  "small",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        },
                                                      },
                                                    ]),
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "invoice-total-item mt-1",
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "invoice-total-title",
                                                },
                                                [_vm._v("Discount:")]
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "invoice-total-amount",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.selectedCurrencySign
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        this.discountTotal.toFixed(
                                                          2
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "invoice-total-item",
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "invoice-total-title",
                                                },
                                                [_vm._v("Subtotal:")]
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "invoice-total-amount",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.selectedCurrencySign
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.subTotal.toFixed(2)
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm.vat
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "invoice-total-item",
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "invoice-total-title",
                                                    },
                                                    [_vm._v("VAT:")]
                                                  ),
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "invoice-total-amount",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.selectedCurrencySign
                                                          ) +
                                                          " " +
                                                          _vm._s(
                                                            _vm.VATtotal.toFixed(
                                                              2
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _c("hr", { staticClass: "my-50" }),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "invoice-total-item",
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "invoice-total-title",
                                                },
                                                [_vm._v("Total:")]
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "invoice-total-amount",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.selectedCurrencySign
                                                      ) +
                                                      " " +
                                                      _vm._s(_vm.finalTotal) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("hr", { staticClass: "invoice-spacing" }),
                          _c(
                            "b-card-body",
                            { staticClass: "invoice-padding pt-0" },
                            [
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v("Note: "),
                              ]),
                              _c("b-form-textarea", {
                                model: {
                                  value: _vm.note,
                                  callback: function ($$v) {
                                    _vm.note = $$v
                                  },
                                  expression: "note",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "validation-observer",
                { ref: "addProduct" },
                [
                  _c(
                    "b-modal",
                    {
                      ref: "addProductModal",
                      attrs: {
                        id: "modal-addProduct",
                        "hide-footer": true,
                        centered: "",
                        title: "Add Product",
                      },
                    },
                    [
                      _c(
                        "b-form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.handleProdSubmit($event)
                            },
                          },
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "b-form-group",
                                    [
                                      _c("label", { attrs: { for: "name" } }, [
                                        _vm._v("Name:"),
                                      ]),
                                      _c("validation-provider", {
                                        attrs: {
                                          rules: "required",
                                          name: "name",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "name",
                                                    type: "text",
                                                    placeholder: "Name",
                                                    required: "",
                                                  },
                                                  model: {
                                                    value: _vm.prodName,
                                                    callback: function ($$v) {
                                                      _vm.prodName = $$v
                                                    },
                                                    expression: "prodName",
                                                  },
                                                }),
                                                errors.length
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger text-end",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "b-form-group",
                                    [
                                      _c("label", { attrs: { for: "qty" } }, [
                                        _vm._v("Quantity:"),
                                      ]),
                                      _c("validation-provider", {
                                        attrs: {
                                          rules: "required",
                                          name: "quantity",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "qty",
                                                    type: "number",
                                                    placeholder: "Quantity",
                                                    required: "",
                                                  },
                                                  on: {
                                                    keypress: function (
                                                      $event
                                                    ) {
                                                      return _vm.allowOnlyNumbersProd(
                                                        $event
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: _vm.prodQty,
                                                    callback: function ($$v) {
                                                      _vm.prodQty = $$v
                                                    },
                                                    expression: "prodQty",
                                                  },
                                                }),
                                                errors.length
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger text-end",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "b-form-group",
                                    [
                                      _c(
                                        "b-form-checkbox",
                                        {
                                          attrs: { id: "checkbox" },
                                          model: {
                                            value: _vm.prodInHouse,
                                            callback: function ($$v) {
                                              _vm.prodInHouse = $$v
                                            },
                                            expression: "prodInHouse",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " Product Manufactured InHouse "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-row",
                            { staticClass: "justify-content-end" },
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "auto" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "ripple",
                                          rawName: "v-ripple.400",
                                          value: "rgba(113, 102, 240, 0.15)",
                                          expression:
                                            "'rgba(113, 102, 240, 0.15)'",
                                          modifiers: { 400: true },
                                        },
                                      ],
                                      attrs: { variant: "primary" },
                                      on: { click: _vm.addProduct },
                                    },
                                    [_vm._v(" Save ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            {
              staticClass: "invoice-actions mt-md-0 mt-2",
              attrs: { cols: "12", md: "4", xl: "3" },
            },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "ripple",
                          rawName: "v-ripple.400",
                          value: "rgba(113, 102, 240, 0.15)",
                          expression: "'rgba(113, 102, 240, 0.15)'",
                          modifiers: { 400: true },
                        },
                      ],
                      attrs: { variant: "outline-primary", block: "" },
                      on: {
                        click: function ($event) {
                          return _vm.addSalesOrder()
                        },
                      },
                    },
                    [
                      _vm.loading
                        ? _c("b-spinner", { attrs: { small: "" } })
                        : _vm._e(),
                      _vm._v(" Save "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }